import type * as React from 'react';

export enum SelectionCardSizeEnum {
	SM = 'sm',
	MD = 'md',
	LG = 'lg',
}

export enum SelectionCardVariantEnum {
	DEFAULT = 'default',
	OUTLINED = 'outlined',
}

export enum SelectionCardAlignmentEnum {
	LEFT = 'left',
	CENTER = 'center',
	RIGHT = 'right',
}

export interface ISelectionCardProps extends Omit<React.ButtonHTMLAttributes<HTMLButtonElement>, 'children'> {
	label: string;
	description?: string;
	icon?: React.ReactNode;
	size?: SelectionCardSizeEnum;
	variant?: SelectionCardVariantEnum;
	alignment?: SelectionCardAlignmentEnum;
	isSelected?: boolean;
	testId?: string;
}
